import * as React from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import type { SortDir } from "@/components/ui/sortable";

interface Props extends React.ThHTMLAttributes<HTMLTableCellElement> {
  active?: boolean;
  dir?: SortDir;
  onSort: () => void;
}

/**
 * SortableHeader wraps <TableHead> with a click target that toggles sort
 * direction on its column. Use with the `useSort` hook.
 */
export function SortableHeader({
  active,
  dir,
  onSort,
  className,
  children,
  ...props
}: Props) {
  const Icon =
    active && dir === "asc" ? ArrowUp : active && dir === "desc" ? ArrowDown : ArrowUpDown;
  return (
    <TableHead className={cn("cursor-pointer select-none", className)} {...props}>
      <button
        type="button"
        onClick={onSort}
        className={cn(
          "inline-flex items-center gap-1.5 -mx-1 px-1 py-0.5 rounded transition-colors hover:bg-surface-muted",
          active && "text-foreground"
        )}
      >
        <span>{children}</span>
        <Icon
          className={cn(
            "size-3 shrink-0",
            active ? "opacity-80" : "opacity-30 group-hover:opacity-60"
          )}
        />
      </button>
    </TableHead>
  );
}
